import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 12\" id=\"icon-arrow--cta\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m9.38 1.199 4.321 4.32a.679.679 0 0 1 0 .961l-4.32 4.321a.679.679 0 1 1-.96-.96l3.161-3.162H1V5.321h10.582L8.42 2.159a.679.679 0 1 1 .96-.96Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol